var FormatStringToLocale = function FormatStringToLocale(str) {
  var isNumber = !isNaN(parseInt(str, 10));

  if (isNumber) {
    var removeCommas = str.replace(/,/g, '') || '0';
    return parseInt(removeCommas, 10).toLocaleString('en-GB');
  }

  return '';
};

export default FormatStringToLocale;
//# sourceMappingURL=number-formatter.js.map